"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var videoplayer_api_client_1 = require("@svt/videoplayer-api-client");

var videoplayer_device_1 = require("@svt/videoplayer-device");

var videoplayer_utils_1 = require("@svt/videoplayer-utils");

var PropTypes = __importStar(require("prop-types"));

var React = __importStar(require("react"));

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

var backends_1 = require("./backends");

var ToggleFullscreenOnOrientationChange_1 = __importDefault(require("./components/behaviors/ToggleFullscreenOnOrientationChange"));

var DefaultUi_1 = __importDefault(require("./components/DefaultUi"));

var ErrorBoundary_1 = __importDefault(require("./components/ErrorBoundary"));

var InViewport_1 = __importDefault(require("./components/InViewport"));

var Loader_1 = __importDefault(require("./components/Loader"));

var MediaSessionManager_1 = __importDefault(require("./components/MediaSessionManager"));

var NoScript_1 = __importDefault(require("./components/NoScript"));

var Poster_1 = __importDefault(require("./components/Poster"));

var SafeAsyncComponent_1 = __importDefault(require("./components/SafeAsyncComponent"));

var Shortcuts_1 = __importDefault(require("./components/Shortcuts"));

var PlayerState_1 = __importDefault(require("./constants/PlayerState"));

var createLoaderObservable_1 = __importDefault(require("./utils/createLoaderObservable"));

var PlayerError_1 = __importDefault(require("./utils/PlayerError"));

var withTheme_1 = require("./utils/withTheme");

var liveRetry_1 = require("./utils/liveRetry");

var videoPlayerStateHandler_1 = require("./videoPlayerStateHandler");

var BreakpointObserver_1 = __importDefault(require("./components/BreakpointObserver"));

var useAltUrls_1 = __importDefault(require("./utils/useAltUrls"));

var videoplayer_device_2 = require("@svt/videoplayer-device");

var SAFE_WIN = typeof window !== 'undefined' ? window : undefined;

var VideoPlayer =
/** @class */
function (_super) {
  __extends(VideoPlayer, _super);

  function VideoPlayer(props) {
    var _this = _super.call(this, props) || this;

    _this.containerElement = null;
    _this.controller$ = new rxjs_1.Subject();
    _this.props$ = new rxjs_1.Subject();
    _this.state$ = new rxjs_1.Subject();
    _this._onMouseUp = _this.bindCallback(_this._onMouseUp);
    _this.getFullscreenElement = _this.bindCallback(_this.getFullscreenElement);
    _this.onInViewportChange = _this.bindCallback(_this.onInViewportChange);
    _this.onBreakpointChange = _this.bindCallback(_this.onBreakpointChange);
    _this.setPlayQueued = _this.bindCallback(_this.setPlayQueued);
    _this.onFatalError = _this.bindCallback(_this.onFatalError);
    _this.onControllerChange = _this.bindCallback(_this.onControllerChange);
    _this.subscription = rxjs_1.merge(_this.createControllerObservable(), _this.createStreamInfoObservable(), _this.createLoadVideoObservable(), _this.createLoaderVisibleObservable()).subscribe(undefined, function (err) {
      _this.safeThrowError(err);
    });
    _this.touchDetector = typeof window !== 'undefined' ? new videoplayer_device_1.TouchDetector(window, navigator) : null;
    _this.state = {
      streamInfo: null,
      playerState: PlayerState_1["default"].STOPPED,
      position: 0,
      duration: 0,
      volume: 0,
      muted: false,
      isCurrentlyInView: false,
      renderFallback: false,
      loaderVisible: false,
      useNativeControls: false,
      isTouch: false,
      getFullscreenElement: _this.getFullscreenElement,
      uiPosition: null,
      playQueued: false,
      controller: null,
      breakPoint: 'small',
      autoPlayWasBlocked: false,
      backendKey: 0
    };
    _this.setState = _this.setState.bind(_this);
    return _this;
  }

  VideoPlayer.prototype.safeComponentDidMount = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;

      return __generator(this, function (_a) {
        this.props$.next(this.props);
        this.state$.next(this.state);

        if (this.touchDetector) {
          this.touchDetector.addEventListener('change', function (isTouch) {
            _this.setState({
              isTouch: isTouch
            });
          });
        }

        if (!videoplayer_device_2.supportsFullUi(document, window)) {
          this.setState({
            useNativeControls: true
          });
        }

        this.setState({
          isTouch: this.touchDetector ? this.touchDetector.isTouch : false
        });
        return [2
        /*return*/
        ];
      });
    });
  };

  VideoPlayer.prototype.safeComponentDidUpdate = function (prevProps, prevState) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        this.props$.next(this.props);
        this.state$.next(this.state);

        if (this.state.renderFallback) {
          return [2
          /*return*/
          ];
        }

        if (this.state.controller && prevProps.maxVideoBitrate !== this.props.maxVideoBitrate) {
          this.state.controller.setMaxVideoBitrate(this.props.maxVideoBitrate || Infinity);
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  VideoPlayer.prototype.safeComponentWillUnmount = function () {
    this.subscription.unsubscribe();

    if (this.touchDetector) {
      this.touchDetector.destroy();
    }

    if (this.state.controller) {
      this.state.controller.dispose();
    }
  };

  VideoPlayer.prototype.render = function () {
    var _this = this;

    var _a;

    if (this.state.renderFallback) {
      return this.renderFallback();
    }

    var PlayerBackend = videoplayer_device_1.isHbbTV(SAFE_WIN) ? backends_1.HbbTvBackend : backends_1.RxPlayerBackend;

    var wrappedPlayer = function wrappedPlayer(shortcutProps) {
      return React.createElement("div", __assign({
        ref: function ref(el) {
          return _this.containerElement = el;
        },
        onMouseUp: _this._onMouseUp,
        tabIndex: 0
      }, shortcutProps), withTheme_1.withTheme(_this.props.theme, 'video-player__video')(React.createElement(PlayerBackend, {
        key: _this.state.backendKey,
        playsInline: _this.props.playsInline,
        debug: _this.props.debug,
        onControllerChange: _this.onControllerChange,
        useNativeControls: _this.state.useNativeControls
      })), withTheme_1.withTheme(_this.props.theme, 'video-player__inner')(
      /*
          When the key prop changes, it will create a new instance of the error boundary.
          This is important because we want to be able to reset the error message.
          
          There might be a better way to identify the current error message
          than using the video ID, but it'll work for now.
      */
      React.createElement(ErrorBoundary_1["default"], {
        key: "inner-error-" + _this.props.videoId,
        onFatalError: _this.onFatalError,
        externalLinks: _this.props.externalLinks
      }, React.createElement("div", null, React.createElement(Poster_1["default"], {
        src: _this.props.poster,
        loop: _this.props.loop,
        playerState: _this.state.playerState,
        autoPlay: _this.props.autoPlay,
        autoPlayWasBlocked: _this.state.autoPlayWasBlocked
      }), React.createElement(MediaSessionManager_1["default"], {
        playerState: _this.state.playerState,
        poster: _this.props.poster,
        episodeTitle: _this.state.streamInfo && _this.state.streamInfo.episodeTitle,
        programTitle: _this.state.streamInfo && _this.state.streamInfo.programTitle
      }), React.createElement(ToggleFullscreenOnOrientationChange_1["default"], {
        isCurrentlyInView: _this.state.isCurrentlyInView,
        getFullscreenElement: _this.getFullscreenElement,
        aspectRatio: _this.props.aspectRatio
      }), React.createElement(InViewport_1["default"], {
        onChange: _this.onInViewportChange
      }), React.createElement(BreakpointObserver_1["default"], {
        onChange: _this.onBreakpointChange
      }), !_this.props.disableUi && !_this.state.useNativeControls && React.createElement(Loader_1["default"], {
        visible: _this.state.loaderVisible
      }), !_this.props.disableUi && React.createElement(DefaultUi_1["default"], {
        controller: _this.state.controller,
        playerState: _this.state.playerState,
        streamInfo: _this.state.streamInfo,
        position: _this.state.position,
        duration: _this.state.duration,
        volume: _this.state.volume,
        muted: _this.state.muted,
        startMuted: _this.props.startMuted,
        splash: Boolean(_this.props.splash),
        autoPlay: Boolean(_this.props.autoPlay),
        useNativeControls: Boolean(_this.state.useNativeControls),
        getFullscreenElement: _this.getFullscreenElement,
        loaderVisible: _this.state.loaderVisible,
        uiPosition: _this.state.uiPosition,
        loop: _this.props.loop,
        setPlayQueued: _this.setPlayQueued,
        poster: _this.props.poster,
        isTouch: _this.state.isTouch
      }), React.createElement(NoScript_1["default"], {
        image: _this.props.poster
      }), _this.renderChildren()))));
    };
    /**
     * The Shortcuts component is supposed to catch all
     * keyboard events. To accomplish that, the listeners are added to the
     * utmost container (shortcutsProps).
     **/


    var shortCuts = this.props.enableShortcuts ? React.createElement(Shortcuts_1["default"], __assign({
      className: this.props.className,
      controller: this.state.controller,
      getFullscreenElement: this.getFullscreenElement,
      setState: this.setState
    }, this.state), wrappedPlayer) : wrappedPlayer({
      className: this.props.className
    });
    return withTheme_1.withTheme(this.props.theme, (_a = {
      'video-player--touch': this.state.isTouch
    }, _a["video-player--" + this.state.breakPoint] = true, _a))(shortCuts);
  };

  VideoPlayer.prototype.renderChildren = function () {
    if (typeof this.props.children === 'function') {
      return this.props.children(this.state, this.state.controller);
    }

    return null;
  };

  VideoPlayer.prototype.renderFallback = function () {
    var embedUrl = 'https://api.svt.se/videoplayer-embed/';
    return withTheme_1.withTheme(this.props.theme, {
      'video-player': true,
      'video-player--16-9': this.props.aspectRatio === '16:9',
      'video-player--9-16': this.props.aspectRatio === '9:16',
      'video-player--square': this.props.aspectRatio === '1:1'
    })(React.createElement("div", null, withTheme_1.withTheme(this.props.theme, 'video-player__video')(React.createElement("iframe", {
      src: "" + embedUrl + this.props.videoId,
      frameBorder: "0",
      allowFullScreen: true
    }))));
  };

  VideoPlayer.prototype.createControllerObservable = function () {
    var _this = this;

    return this.controller$.pipe(operators_1.distinctUntilChanged(), operators_1.filter(videoplayer_utils_1.isNotNull), operators_1.catchError(function () {
      _this.setState({
        renderFallback: true
      });

      return rxjs_1.of(null);
    }), operators_1.filter(videoplayer_utils_1.isNotNull), operators_1.tap(function (controller) {
      _this.setupPlayer(controller);

      _this.setState({
        controller: controller,
        volume: controller.getVolume(),
        muted: controller.isMute()
      });
    }));
  };

  VideoPlayer.prototype.createStreamInfoObservable = function () {
    var _this = this;

    return this.props$.pipe(operators_1.map(function (props) {
      return props.videoId;
    }), operators_1.distinctUntilChanged(), operators_1.tap(function (videoId) {
      /**
       * Stop current playback when switching video. This important when switching video
       * with preload false, because we don't want the previous video to keep downloading
       * segments.
       */
      if (_this.state.controller !== null && _this.state.playerState !== PlayerState_1["default"].STOPPED) {
        _this.state.controller.stop();
      }

      _this.setState(videoPlayerStateHandler_1.resetState());
    }), operators_1.switchMap(function (videoId) {
      return videoplayer_api_client_1.fetchStreamInfo(videoId);
    }), operators_1.switchMap(function (streamInfo) {
      return liveRetry_1.shouldLiveRetry(streamInfo) ? liveRetry_1.liveRetryStreamInfo(streamInfo).pipe(operators_1.startWith(streamInfo)) : rxjs_1.of(streamInfo);
    }), operators_1.catchError(function (err) {
      // Re-throw fetch errors as a fatal PlayerError.
      return rxjs_1.throwError(new PlayerError_1["default"]('Could not fetch stream info from API', {
        innerError: err,
        fatal: true
      }));
    }),
    /*
     * The alt-URL is a parameter that is attached to the video reference:
      * I.e:
     *   https://svt.akamaihd.net/delivery/1383013-001A/manifet.mpd?alt=https%3A%2F%2Fswitcher.cdn.svt.se%2F1383013-001A_072aba30.mpd"
     *
     * In the example above, the decoded alt-URL is https://switcher.cdn.svt.se/1383013-001A_072aba30.mpd
     *
     * A switcher URL will is a proxy/load balancer that distribute traffic to
     * different CDNs depending of current traffic load. This is done through a
     * 302 redirect. However, not all browsers/environments support/follow
     * redirects in video manifests. In that case, we will use the Akamai URL
     * directly.
     */
    operators_1.map(function (streamInfo) {
      return useAltUrls_1["default"](streamInfo, SAFE_WIN);
    }), operators_1.tap(function (streamInfo) {
      _this.setState({
        streamInfo: streamInfo,

        /*
         * Set playQueued to true when a live countdown is running,
         * this makes sure that the video is autoplayed when the
         * video stream has started.
         */
        playQueued: streamInfo.secondsToLiveRetry !== null && streamInfo.secondsToLiveRetry > 0 ? true : _this.state.playQueued
      });
    }));
  };

  VideoPlayer.prototype.createLoadVideoObservable = function () {
    var _this = this;

    var shouldLoad$ = rxjs_1.combineLatest(this.props$, this.state$).pipe(operators_1.map(function (_a) {
      var props = _a[0],
          state = _a[1];
      /*
       * If autoPlay is set to true, it should override the preload=false setting
       */

      if (props.preload === true || props.autoPlay) {
        return true;
      }
      /*
       * If preload is disabled, we'll check if the user has had an intention to start
       * the video.
       */


      return state.playQueued;
    }), operators_1.distinctUntilChanged());
    var streamInfo$ = this.state$.pipe(operators_1.map(function (state) {
      return state.streamInfo;
    }), operators_1.distinctUntilChanged());
    var controller$ = this.state$.pipe(operators_1.map(function (state) {
      return state.controller;
    }), operators_1.distinctUntilChanged());
    return rxjs_1.combineLatest(streamInfo$, controller$, shouldLoad$).pipe(operators_1.filter(videoplayer_utils_1.tupleElementsNotNull), operators_1.filter(function (_a) {
      var streamInfo = _a[0],
          controller = _a[1],
          shouldLoad = _a[2];
      return shouldLoad && Object.keys(streamInfo.videoReferences).length > 0 && (streamInfo.liveStart === null || streamInfo.liveStart !== null && streamInfo.liveNow);
    }), operators_1.tap(function (_a) {
      var streamInfo = _a[0],
          controller = _a[1];

      if (_this.props.startMuted) {
        controller.mute();
      } else {
        controller.unMute();
      }

      controller.loadVideo(streamInfo, {
        autoPlay: _this.props.autoPlay || _this.state.playQueued,
        startPosition: _this.props.startPosition
      });
    }), operators_1.catchError(function (err) {
      if (err.message === 'Browser is not supported') {
        _this.setState({
          renderFallback: true
        });

        return rxjs_1.EMPTY;
      }

      return rxjs_1.throwError(new PlayerError_1["default"](err.message, {
        innerError: err,
        fatal: true
      }));
    }));
  };

  VideoPlayer.prototype.createLoaderVisibleObservable = function () {
    var _this = this;

    var loaderObservableProps$ = rxjs_1.combineLatest(this.props$, this.state$).pipe(operators_1.map(function (_a) {
      var props = _a[0],
          state = _a[1];
      return {
        playerState: state.playerState,
        autoPlay: props.autoPlay || false,
        playQueued: state.playQueued
      };
    }));
    return createLoaderObservable_1["default"](loaderObservableProps$).pipe(operators_1.tap(function (loaderVisible) {
      return _this.setState({
        loaderVisible: loaderVisible
      });
    }));
  };

  VideoPlayer.prototype.onControllerChange = function (controller) {
    this.controller$.next(controller);
  };

  VideoPlayer.prototype.getFullscreenElement = function () {
    if (this.state.controller instanceof backends_1.RxPlayerController) {
      // On iOS, the fullscreen API is only available for video|img tags
      return videoplayer_device_1.isIos(window) ? this.state.controller.getVideoElement() : this.containerElement;
    }

    return null;
  };

  VideoPlayer.prototype.onInViewportChange = function (isCurrentlyInView) {
    this.setState({
      isCurrentlyInView: isCurrentlyInView
    });
  };

  VideoPlayer.prototype.onBreakpointChange = function (breakPoint) {
    this.setState({
      breakPoint: breakPoint
    });
  };

  VideoPlayer.prototype.setPlayQueued = function () {
    this.setState({
      playQueued: true
    });
  };

  VideoPlayer.prototype.onFatalError = function (error) {
    if (this.state.controller) {
      this.state.controller.dispose();
      this.setState({
        controller: null,

        /*
         * The backend key incrementation tells the backend player component
         * to be re-created (= a new instance will be created) on the
         * next render cycle.
         */
        backendKey: this.state.backendKey + 1
      });
    }
  };

  VideoPlayer.prototype.setupPlayer = function (controller) {
    /*
     * Configure controller
     */
    var _this = this;

    if (this.props.maxVideoBitrate) {
      controller.setMaxVideoBitrate(this.props.maxVideoBitrate);
    }
    /*
     * Setup listeners
     */


    controller.addEventListener('playerStateChange', function (playerState) {
      if (_this.state.controller) {
        _this.setState(videoPlayerStateHandler_1.playerStateChange(playerState, controller));

        if (_this.props.loop && playerState === PlayerState_1["default"].ENDED) {
          _this.state.controller.seekTo(0);

          _this.state.controller.play();
        }
      }
    });
    controller.addEventListener('positionUpdate', function (positionObject) {
      _this.setState(videoPlayerStateHandler_1.positionUpdate(positionObject));
    });
    controller.addEventListener('videoBitrateChange', function (videoBitrate) {
      _this.setState(videoPlayerStateHandler_1.videoBitrateChange(videoBitrate));
    });
    controller.addEventListener('audioBitrateChange', function (audioBitrate) {
      _this.setState(videoPlayerStateHandler_1.audioBitrateChange(audioBitrate));
    });
    controller.addEventListener('volumeChange', function (volume) {
      if (controller) {
        _this.setState(videoPlayerStateHandler_1.volumeChange(volume, controller));
      }
    });
    controller.addEventListener('error', function (error) {
      _this.safeThrowError(new PlayerError_1["default"](error.message, {
        innerError: error,
        fatal: error.fatal
      }));
    });
    controller.addEventListener('warning', function (error) {
      if (error.code === 'MEDIA_ERR_BLOCKED_AUTOPLAY') {
        _this.setState(videoPlayerStateHandler_1.autoPlayWasBlocked());
      }

      _this.safeThrowError(new PlayerError_1["default"](error.message, {
        innerError: error,
        fatal: false
      }));
    });
  };

  VideoPlayer.prototype._onMouseUp = function (e) {
    if (this.containerElement) {
      this.containerElement.focus();
    }
  };

  VideoPlayer.propTypes = {
    videoId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };
  VideoPlayer.contextTypes = __assign({}, SafeAsyncComponent_1["default"].contextTypes, {
    theme: PropTypes.object
  });
  VideoPlayer.defaultProps = {
    enableShortcuts: true,
    autoPlay: true,
    disableUi: false,
    playsInline: true,
    splash: true,
    preload: true
  };
  return VideoPlayer;
}(SafeAsyncComponent_1["default"]);

exports["default"] = VideoPlayer;